import React, { cloneElement } from 'react';
import { motion } from 'framer-motion';
import { Eyebrow } from './UI';
import { Shield, RefreshCw, Zap, Phone } from 'lucide-react';
export const Guarantee = () => {
  const points = [{
    icon: <Shield className="text-acid-green" size={24} data-id="element-171" />,
    title: 'LIFETIME STRUCTURAL WARRANTY',
    sub: 'Frame, shell & strap covered — forever.'
  }, {
    icon: <RefreshCw className="text-acid-green" size={24} data-id="element-172" />,
    title: '30-DAY FREE RETURNS',
    sub: "Didn't love it? We pick it up at no cost."
  }, {
    icon: <Zap className="text-acid-green" size={24} data-id="element-173" />,
    title: '48-HOUR REPLACEMENT',
    sub: 'Valid claims processed in two business days.'
  }, {
    icon: <Phone className="text-acid-green" size={24} data-id="element-174" />,
    title: 'REAL HUMANS. REAL SUPPORT.',
    sub: 'Call, email, or chat — 7 days a week.'
  }];
  return <section className="bg-gradient-to-b from-dark-1 to-acid-green/5 border-y border-acid-green/10 py-[100px]" data-id="element-175">
      <div className="container mx-auto px-6 md:px-12" data-id="element-176">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-177">
          {/* Left - Badge */}
          <div className="w-full lg:w-1/3 flex justify-center" data-id="element-178">
            <div className="relative w-[320px] h-[320px]" data-id="element-179">
              {/* Corner brackets — pulse */}
              {[{
              pos: 'top-0 left-0',
              rot: 0
            }, {
              pos: 'top-0 right-0',
              rot: 90
            }, {
              pos: 'bottom-0 right-0',
              rot: 180
            }, {
              pos: 'bottom-0 left-0',
              rot: 270
            }].map((c, i) => <motion.div key={i} className={`absolute ${c.pos} w-8 h-8 z-30`} style={{
              transform: `rotate(${c.rot}deg)`
            }} animate={{
              opacity: [0.4, 1, 0.4]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              delay: i * 0.2
            }} data-id="element-180">
                  <div className="absolute top-0 left-0 w-full h-[2px] bg-acid-green" data-id="element-181" />
                  <div className="absolute top-0 left-0 w-[2px] h-full bg-acid-green" data-id="element-182" />
                </motion.div>)}

              {/* Outer rotating ring with tick marks */}
              <motion.svg viewBox="0 0 200 200" className="absolute inset-0 w-full h-full" animate={{
              rotate: 360
            }} transition={{
              duration: 30,
              ease: 'linear',
              repeat: Infinity
            }} data-id="element-183">
                <circle cx="100" cy="100" r="92" fill="none" stroke="rgba(200,255,0,0.5)" strokeWidth="1" strokeDasharray="2 4" data-id="element-184" />
                {/* Major tick marks every 30deg */}
                {Array.from({
                length: 12
              }).map((_, i) => <line key={i} x1="100" y1="4" x2="100" y2={i % 3 === 0 ? 14 : 10} stroke="#C8FF00" strokeWidth={i % 3 === 0 ? 2 : 1} transform={`rotate(${i * 30} 100 100)`} data-id="element-185" />)}
                {/* Cardinal labels */}
                {['N', 'E', 'S', 'W'].map((dir, i) => <text key={dir} x="100" y="22" textAnchor="middle" fill="#C8FF00" fontSize="7" fontFamily="Barlow Condensed, sans-serif" fontWeight="700" transform={`rotate(${i * 90} 100 100)`} data-id="element-186">
                    {dir}
                  </text>)}
              </motion.svg>

              {/* Inner counter-rotating ring */}
              <motion.svg viewBox="0 0 200 200" className="absolute inset-0 w-full h-full" animate={{
              rotate: -360
            }} transition={{
              duration: 45,
              ease: 'linear',
              repeat: Infinity
            }} data-id="element-187">
                <circle cx="100" cy="100" r="78" fill="none" stroke="rgba(200,255,0,0.25)" strokeWidth="1" data-id="element-188" />
                {/* Range gradient marks at 4 quadrants */}
                {[0, 90, 180, 270].map(deg => <g key={deg} transform={`rotate(${deg} 100 100)`} data-id="element-189">
                    <line x1="100" y1="22" x2="100" y2="32" stroke="#C8FF00" strokeWidth="1.5" data-id="element-190" />
                    <text x="100" y="42" textAnchor="middle" fill="#C8FF00" fontSize="5" fontFamily="Barlow Condensed, sans-serif" data-id="element-191">
                      {deg === 0 ? '300m' : deg === 90 ? '500m' : deg === 180 ? '700m' : '100m'}
                    </text>
                  </g>)}
              </motion.svg>

              {/* Reticle — crosshair + mil-dots — STATIC */}
              <svg viewBox="0 0 200 200" className="absolute inset-0 w-full h-full pointer-events-none" data-id="element-192">
                {/* Vertical crosshair with center gap */}
                <line x1="100" y1="14" x2="100" y2="80" stroke="#C8FF00" strokeWidth="1" data-id="element-193" />
                <line x1="100" y1="120" x2="100" y2="186" stroke="#C8FF00" strokeWidth="1" data-id="element-194" />
                {/* Horizontal crosshair with center gap */}
                <line x1="14" y1="100" x2="80" y2="100" stroke="#C8FF00" strokeWidth="1" data-id="element-195" />
                <line x1="120" y1="100" x2="186" y2="100" stroke="#C8FF00" strokeWidth="1" data-id="element-196" />
                {/* Mil-dots on vertical */}
                {[40, 55, 70, 130, 145, 160].map((y, i) => <circle key={`v${i}`} cx="100" cy={y} r="1.4" fill="#C8FF00" data-id="element-197" />)}
                {/* Mil-dots on horizontal */}
                {[40, 55, 70, 130, 145, 160].map((x, i) => <circle key={`h${i}`} cx={x} cy="100" r="1.4" fill="#C8FF00" data-id="element-198" />)}
                {/* Tick numbers on vertical (elevation) */}
                <text x="106" y="42" fill="#C8FF00" fontSize="5" fontFamily="Barlow Condensed, sans-serif" data-id="element-199">
                  +3
                </text>
                <text x="106" y="162" fill="#C8FF00" fontSize="5" fontFamily="Barlow Condensed, sans-serif" data-id="element-200">
                  -3
                </text>
              </svg>

              {/* Scanning line — vertical sweep */}
              <motion.div className="absolute inset-x-[12%] top-0 h-[1px] bg-gradient-to-r from-transparent via-acid-green to-transparent pointer-events-none" style={{
              boxShadow: '0 0 8px #C8FF00'
            }} animate={{
              y: ['10%', '90%', '10%']
            }} transition={{
              duration: 4,
              ease: 'easeInOut',
              repeat: Infinity
            }} data-id="element-201" />

              {/* Center pulsing target */}
              <motion.div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-acid-green pointer-events-none" animate={{
              scale: [1, 1.6, 1],
              opacity: [1, 0.4, 1]
            }} transition={{
              duration: 1.4,
              repeat: Infinity,
              ease: 'easeInOut'
            }} style={{
              boxShadow: '0 0 12px #C8FF00'
            }} data-id="element-202" />

              {/* Center content panel — sits on top of reticle */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[160px] h-[160px] flex flex-col items-center justify-center text-center bg-base-black/85 backdrop-blur-sm border border-acid-green/40 z-20" data-id="element-203">
                <Shield className="text-acid-green mb-2" size={28} data-id="element-204" />
                <div className="font-bebas text-[24px] text-white leading-none mb-1" data-id="element-205">
                  LIFETIME
                  <br data-id="element-206" />
                  WARRANTY
                </div>
                <div className="w-10 h-[1px] bg-acid-green/60 my-2" data-id="element-207"></div>
                <div className="font-barlow text-[9px] text-acid-green tracking-[2px] uppercase" data-id="element-208">
                  Zero Fine Print
                </div>
              </div>

              {/* HUD readout — top */}
              <motion.div className="absolute -top-2 left-1/2 -translate-x-1/2 font-barlow text-[9px] text-acid-green tracking-[2px] bg-base-black px-2 py-0.5 border border-acid-green/40 z-30" animate={{
              opacity: [0.6, 1, 0.6]
            }} transition={{
              duration: 1.5,
              repeat: Infinity
            }} data-id="element-209">
                ● TARGET LOCKED
              </motion.div>

              {/* HUD readout — bottom */}
              <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 font-barlow text-[9px] text-acid-green tracking-[2px] bg-base-black px-2 py-0.5 border border-acid-green/40 z-30" data-id="element-210">
                MAG 4.5× / FOV 8°
              </div>
            </div>
          </div>

          {/* Right - Warranty Dossier */}
          <div className="w-full lg:w-2/3" data-id="element-211">
            {/* Dossier metadata strip */}
            <div className="flex flex-wrap items-center justify-between gap-3 border-b border-dark-3 pb-3 mb-6" data-id="element-212">
              <div className="flex items-center gap-3 font-barlow text-[10px] tracking-[2px] text-text-dimmed uppercase" data-id="element-213">
                <span className="text-acid-green" data-id="element-214">●</span>
                <span data-id="element-215">FILE 004 — WARRANTY DOCTRINE</span>
                <span className="hidden md:inline text-dark-3" data-id="element-216">|</span>
                <span className="hidden md:inline" data-id="element-217">STATUS: ACTIVE</span>
              </div>
              <div className="font-barlow text-[10px] tracking-[2px] text-acid-green uppercase" data-id="element-218">
                ENFORCED BY BLACKOUT UNIT TEAM
              </div>
            </div>

            <Eyebrow data-id="element-219">OUR COMMITMENT</Eyebrow>
            <h2 className="text-4xl md:text-[52px] leading-[0.95] mb-6" data-id="element-220">
              WE BACK EVERY BLACKOUT UNIT™{' '}
              <span className="text-acid-green" data-id="element-221">FOR LIFE.</span>
            </h2>

            {/* Pull-quote block */}
            <div className="border-l-2 border-acid-green pl-5 py-1 mb-8 max-w-2xl" data-id="element-222">
              <p className="font-barlow font-bold text-[12px] text-acid-green tracking-[2px] uppercase mb-3" data-id="element-223">
                — Field Doctrine —
              </p>
              <div className="font-barlow text-[16px] md:text-[17px] text-text-body leading-[1.85] space-y-3" data-id="element-224">
                <p data-id="element-225">
                  "We built the BLACKOUT UNIT Ultimate Mask to last a lifetime —
                  and we back that claim with a warranty that does the same.
                </p>
                <p data-id="element-226">
                  If your mask ever fails under normal use, we replace it. No
                  forms. No wait. No runaround. No 'submit a ticket and wait 14
                  business days.' One call. One email. Handled.
                </p>
                <p className="text-white font-medium" data-id="element-227">
                  Because operators don't have time for fine print — and neither
                  do we."
                </p>
              </div>
            </div>

            {/* Numbered commitment list — tactical dossier style */}
            <div className="border border-dark-3 bg-dark-1" data-id="element-228">
              {/* Header row */}
              <div className="hidden md:grid grid-cols-[60px_120px_1fr_140px] items-center gap-4 px-5 py-2.5 border-b border-dark-3 bg-base-black" data-id="element-229">
                <div className="font-barlow text-[10px] text-text-dimmed tracking-[2px]" data-id="element-230">
                  CLAUSE
                </div>
                <div className="font-barlow text-[10px] text-text-dimmed tracking-[2px]" data-id="element-231">
                  SCOPE
                </div>
                <div className="font-barlow text-[10px] text-text-dimmed tracking-[2px]" data-id="element-232">
                  PROVISION
                </div>
                <div className="font-barlow text-[10px] text-text-dimmed tracking-[2px] text-right" data-id="element-233">
                  STATUS
                </div>
              </div>

              {points.map((p, i) => {
              const scope = ['STRUCTURAL', 'RETURNS', 'REPLACEMENT', 'SUPPORT'][i];
              return <div key={i} className="group grid grid-cols-[40px_1fr_auto] md:grid-cols-[60px_120px_1fr_140px] items-center gap-4 px-5 py-4 border-b border-dark-3 last:border-b-0 hover:bg-base-black transition-colors relative" data-id="element-234">
                    {/* Left accent bar on hover */}
                    <div className="absolute left-0 top-0 bottom-0 w-[2px] bg-acid-green opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-235" />

                    <div className="font-bebas text-[22px] text-acid-green leading-none" data-id="element-236">
                      {String(i + 1).padStart(2, '0')}
                    </div>
                    <div className="hidden md:flex items-center gap-2 font-barlow text-[11px] text-acid-green tracking-[2px]" data-id="element-237">
                      {p.icon && cloneElement(p.icon as React.ReactElement, {
                    size: 14
                  })}
                      {scope}
                    </div>
                    <div data-id="element-238">
                      <h4 className="font-bebas text-[18px] text-white leading-none mb-1" data-id="element-239">
                        {p.title}
                      </h4>
                      <p className="font-inter text-[12px] text-text-dimmed leading-snug" data-id="element-240">
                        {p.sub}
                      </p>
                    </div>
                    <div className="hidden md:flex justify-end items-center gap-1.5 font-barlow text-[10px] text-acid-green tracking-[2px]" data-id="element-241">
                      <span className="w-1.5 h-1.5 rounded-full bg-acid-green animate-pulse" data-id="element-242" />
                      ENFORCED
                    </div>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
};